// import React from 'react';
// import './CliniciansImageSection.scss';

// // Example JSON data for the section
// const cliniciansTrustData = {
//   image: '/images/icons/trust-image.png', // Place your image here
//   title: 'WHY CLINICIANS TRUST CELBION BRANDS',
//   points: [
//     'Clear mechanism of action',
//     'Clinically justified dosages',
//     'Designed for chronic safety and adherence',
//     'Ethical positioning without exaggerated claims',
//   ],
//   philosophyTitle: "Celbion's Rational Brand Development Philosophy",
//   philosophy: [
//     'One disease • one dominant mechanism • one rational solution',
//     'We consciously avoid:',
//     'No ingredient crowding',
//     'Short-term symptomatic exaggeration',
//     'All Celbion brands are designed for chronic use, predictable safety, and long-term clinician confidence.'
//   ]
// };

// export default function CliniciansImageSection() {
//   return (
//     <div className="clinicians-image-section">
//       <img src={cliniciansTrustData.image} alt="Trust Word Cloud" className="trust-image" />
//       <div className="trust-content">
//         <h2>{cliniciansTrustData.title}</h2>
//         <ul>
//           {cliniciansTrustData.points.map((point, idx) => (
//             <li key={idx}>{point}</li>
//           ))}
//         </ul>
//         <h3>{cliniciansTrustData.philosophyTitle}</h3>
//         <ul>
//           {cliniciansTrustData.philosophy.map((item, idx) => (
//             <li key={idx}>{item}</li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// }

import React from 'react';
import './CliniciansImageSection.scss';

const cliniciansTrustData = {
  badge: 'Clinician Confidence Report',
  title: 'Why Clinicians Trust',
  titleHighlight: 'Celbion Brands',
  points: [
    'Clear mechanism of action',
    'Clinically justified dosages',
    'Designed for chronic safety and adherence',
    'Ethical positioning without exaggerated claims',
  ],
  philosophyTitle: "Celbion's Rational Brand Development Philosophy",
  corePrinciple: 'One disease · one dominant mechanism · one rational solution',
  avoidLabel: 'We consciously avoid',
  avoidItems: [
    'Ingredient crowding',
    'Short-term symptomatic exaggeration',
  ],
  footerNote: {
    prefix: 'All Celbion brands are designed for ',
    highlight1: 'chronic use',
    middle: ', predictable safety, and long-term ',
    highlight2: 'clinician confidence',
    suffix: '.',
  },
  stats: [
    { num: '100%', label: 'Chronic-use ready' },
    { num: '0',    label: 'Exaggerated claims' },
    { num: '1:1:1', label: 'Disease · mechanism · solution' },
  ],
};

function CheckIcon() {
  return (
    <svg viewBox="0 0 10 10" fill="none" width="16" height="16">
      <polyline
        points="2,5 4,7 8,3"
        stroke="#4da3ff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default function CliniciansImageSection() {
  const d = cliniciansTrustData;
  return (
    <section className="cs-root">
      <div className="cs-grid" aria-hidden="true" />
      <div className="container cs-inner">

        <div className="cs-badge">
          <span className="cs-badge-dot" />
          {d.badge}
        </div>

        <h1 className="cs-title">
          {d.title} <span className="cs-title-highlight">{d.titleHighlight}</span>
        </h1>

        {/* Word Cloud Image */}
        <div className="cs-image-container">
          <img
            src="/images/icons/trust-image.png"
            alt="Trust word cloud showing clinician confidence factors"
            className="cs-word-cloud"
          />
        </div>

        <div className="cs-columns">
          {/* Trust Points */}
          <div className="cs-card">
            <p className="cs-card-label">Evidence-Based Pillars</p>
            <ul className="cs-points">
              {d.points.map((point, idx) => (
                <li key={idx} className="cs-point">
                  <span className="cs-point-icon"><CheckIcon /></span>
                  {point}
                </li>
              ))}
            </ul>
          </div>

          {/* Philosophy */}
          <div className="cs-philosophy">
            <h3 className="cs-phil-title">{d.philosophyTitle}</h3>
            <div className="cs-principle">{d.corePrinciple}</div>
            <p className="cs-avoid-label">{d.avoidLabel}</p>
            <div className="cs-avoid-items">
              {d.avoidItems.map((item, idx) => (
                <div key={idx} className="cs-avoid-item">
                  <span className="cs-avoid-dash" />
                  {item}
                </div>
              ))}
            </div>
            <p className="cs-footer-note">
              {d.footerNote.prefix}
              <strong>{d.footerNote.highlight1}</strong>
              {d.footerNote.middle}
              <strong>{d.footerNote.highlight2}</strong>
              {d.footerNote.suffix}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}